import React from 'react';
import { Section } from '../../../components/section';
import { Text } from '../../../components/text';

const ProviderReferenceThankYou: React.FC<{ provider: Provider }> = ({ provider }) => {
  return (
    <>
      <main className="tw:max-w-5xl tw:mx-auto tw:px-4 tw:pt-3 tw:pb-8 tw:dark:bg-zinc-700">
        {/* Main Thank You Card */}
        <Section>
          {/* Success Icon and Title */}
          <div className="tw:text-center tw:mb-8">
            <div className="tw:inline-flex tw:items-center tw:justify-center tw:w-16 tw:h-16 tw:bg-green-100 tw:rounded-full tw:mb-4 tw:dark:bg-brand-green-1/10 tw:dark:border tw:dark:border-brand-green-1">
              <i className="fas fa-check tw:text-3xl tw:text-green-600 tw:dark:text-brand-green-1" />
            </div>
            {/* TODO DARK MODE STYLES need to use global dark mode heading styles */}
            <h1 className="tw:text-3xl tw:font-bold tw:dark:!text-brand-green-1 tw:mb-2">
              Thank You for Your Reference!
            </h1>
            <Text>
              Your reference for {provider.prefix_name ? `${provider.prefix_name} ` : ''}{' '}
              {provider.preferred_name} {provider.last_name} has been successfully submitted.
              Contributions from professionals like you are vital to maintaining the integrity and
              quality of healthcare services.
            </Text>
          </div>

          {/* TODO: these extra sections below are meant to be part of a soft-sell approach to the reference process
          e.g. reference summary, requesting provider summary, generally more official-looking and app-like */}

          {/* Provider Details */}
          {/* <div className="tw:flex tw:flex-col tw:items-center tw:mb-8">
            <div className="tw:w-24 tw:h-24 tw:bg-zinc-200 tw:rounded-full tw:mb-4 tw:flex tw:items-center tw:justify-center">
              <i className="fas fa-user tw:text-4xl tw:text-zinc-400" />
            </div>
            <h2 className="tw:text-xl tw:font-bold tw:text-zinc-900 tw:mb-2">
              {REQUESTING_PROVIDER_NAME}
            </h2>
            <p className="tw:text-zinc-600 tw:mb-2">{PROVIDER_SPECIALTY}</p>
          </div> */}

          {/* Reference Summary */}
          {/* <div className="tw:mb-8 tw:bg-zinc-100/50 tw:rounded-lg tw:p-4">
            <p className="tw:mb-4">Your Reference Summary:</p>
            <div className="tw:space-y-3">
              <div className="tw:flex tw:items-center tw:text-zinc-700">
                <i className="fas fa-user tw:text-lg tw:mr-3 tw:text-brand-green-1" />
                <span>Professional relationship: {RELATIONSHIP_TYPE}</span>
              </div>
              <div className="tw:flex tw:items-center tw:text-zinc-700">
                <i className="fas fa-clock tw:text-lg tw:mr-3 tw:text-brand-green-1" />
                <span>Relationship duration: {RELATIONSHIP_DURATION}</span>
              </div>
              <div className="tw:flex tw:items-center tw:text-zinc-700">
                <i className="fas fa-thumbs-up tw:text-lg tw:mr-3 tw:text-brand-green-1" />
                <span>Recommendation status: {RECOMMENDATION_STATUS}</span>
              </div>
            </div>
          </div> */}

          {/* Action Buttons */}
          {/* <div className="tw:flex tw:flex-col sm:tw:flex-row tw:gap-4 tw:justify-center">
            <Button className="tw:bg-blue-600 tw:text-white tw:hover:bg-blue-700 tw:px-8 tw:py-3">
              Return to Dashboard
            </Button>
            <Button
              plain
              className="tw:border tw:border-blue-600 tw:text-blue-600 tw:hover:bg-blue-50 tw:px-8 tw:py-3"
            >
              Endorse Another Physician
            </Button>
          </div> */}
        </Section>

        {/* Healthcare Professional CTA */}
        <div className="tw:bg-brand-green-0/10 tw:rounded-lg tw:p-6 tw:mb-6 tw:dark:bg-brand-green-1/10 tw:dark:border tw:dark:border-brand-green-1">
          <div className="tw:flex tw:items-start">
            <i className="fas fa-question-circle tw:text-xl tw:text-brand-green-1 tw:mr-3 tw:mt-1" />
            <div>
              {/* TODO DARK MODE STYLES need to use global dark mode heading styles */}
              <h3 className="tw:mb-2 tw:dark:!text-brand-green-1">Ready to Join Sendit?</h3>
              <Text className="tw:mb-3">
                Set your preferred contract rate, receive peer endorsements, and connect with
                healthcare organizations without the middleman.
              </Text>
              <a
                href="/register/provider/setup?utm_campaign=provider-references&utm_medium=web&utm_source=reference-thankyou&utm_content=signup"
                // TODO: LINK STYLES need to define these globally
                className="tw:text-brand-green-1 tw:dark:text-brand-green-1 tw:font-medium hover:tw:text-brand-green-1/90"
              >
                Create your account →
              </a>
            </div>
          </div>
        </div>

        {/* What happens next */}
        {/* <div className="tw:bg-white tw:rounded-lg tw:border tw:border-zinc-200 tw:p-6 tw:mb-6 tw:dark:bg-zinc-700 tw:dark:border tw:dark:border-zinc-400">
          <h3 className="tw:mb-4">What happens next?</h3>
          <ol className="tw:space-y-3 tw:text-zinc-700">
            <li className="tw:flex">
              <span className="tw:inline-flex tw:items-center tw:justify-center tw:w-6 tw:h-6 tw:bg-brand-green-0/10 tw:text-brand-green-1 tw:text-sm tw:font-medium tw:rounded-full tw:mr-3 tw:flex-shrink-0">
                1
              </span>
              <span>
                Your endorsement will be reviewed for completeness and added to Dr. Wilson&apos;s
                professional profile.
              </span>
            </li>
            <li className="tw:flex">
              <span className="tw:inline-flex tw:items-center tw:justify-center tw:w-6 tw:h-6 tw:bg-brand-green-0/10 tw:text-brand-green-1 tw:text-sm tw:font-medium tw:rounded-full tw:mr-3 tw:flex-shrink-0">
                2
              </span>
              <span>
                Dr. Wilson will be notified of your endorsement (your identity will remain private
                if you selected that option).
              </span>
            </li>
            <li className="tw:flex">
              <span className="tw:inline-flex tw:items-center tw:justify-center tw:w-6 tw:h-6 tw:bg-brand-green-0/10 tw:text-brand-green-1 tw:text-sm tw:font-medium tw:rounded-full tw:mr-3 tw:flex-shrink-0">
                3
              </span>
              <span>
                Your feedback contributes to healthcare quality assurance and helps organizations
                make informed decisions.
              </span>
            </li>
          </ol>
        </div> */}

        {/* Share with others */}
        {/* <div className="tw:bg-white tw:rounded-lg tw:border tw:border-zinc-200 tw:p-6 tw:mb-6 tw:dark:bg-zinc-700 tw:dark:border tw:dark:border-zinc-400">
          <h3 className="tw:text-lg tw:font-semibold tw:text-zinc-900 tw:mb-2">
            Know other professionals who&apos;ve worked with {REQUESTING_PROVIDER_NAME}?
          </h3>
          <p className="tw:text-zinc-700 tw:mb-4">
            Help build a comprehensive profile by sharing this endorsement survey with other
            qualified peers.
          </p>
          <div className="tw:flex tw:gap-3">
            <Button
              plain
              className="tw:bg-zinc-100 tw:text-zinc-700 tw:hover:bg-zinc-200 tw:px-4 tw:py-2 tw:flex tw:items-center"
            >
              <i className="fas fa-envelope tw:text-sm tw:mr-2" />
              Email
            </Button>
            <Button
              plain
              className="tw:bg-zinc-100 tw:text-zinc-700 tw:hover:bg-zinc-200 tw:px-4 tw:py-2 tw:flex tw:items-center"
            >
              <i className="fab fa-linkedin tw:text-sm tw:mr-2" />
              LinkedIn
            </Button>
            <Button
              plain
              className="tw:bg-zinc-100 tw:text-zinc-700 tw:hover:bg-zinc-200 tw:px-4 tw:py-2 tw:flex tw:items-center"
            >
              <i className="fas fa-link tw:text-sm tw:mr-2" />
              Copy Link
            </Button>
          </div>
        </div> */}
      </main>
    </>
  );
};

export default ProviderReferenceThankYou;
